import React, { useEffect } from 'react';

import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
export const ErrorWarningPageHelp = () => {
  var errWarnJsonArr = [
    {
      fieldName: 'Customer Submission Group',
      description: 'Identifies the Submission Group being viewed.',
    },
    {
      fieldName: 'Customer File Name',
      description: 'Name of the file processed.',
    },
    {
      fieldName: 'Processing Date',
      description: 'Date the transaction set was processed.',
    },
    {
      fieldName: 'Processing Status',
      description: '',
    },
  ];

  var procStatusJsonArr = [
    {
      statusCode: 'COMPLETE',
      explantion:
        'Transaction set has been processed and all records have been updated to the Electronic Eligibility Management System.',
    },
    {
      statusCode: 'COMPLETED WITH WARNINGS',
      explantion:
        'Transaction set has been processed, but with low severity errors (warnings) detected on some records.  All records have been updated to the Electronic Eligibility Management System; however, those records with warnings should be corrected by the customer via the next file submission to resolve inaccurate data.',
    },
    {
      statusCode: 'COMPLETED WITH ERRORS',
      explantion:
        'Transaction set has been processed, but with errors detected on some records.  Those records not in error have been updated to the eligibility system, error records are pended in the Electronic Eligibility Management System process until resolved by the Electronic Eligibility Analyst assigned to the submission group or corrected by a new file submission from the customer.',
    },
    {
      statusCode: 'CMPL REPR ALL',
      explantion:
        'Transaction set has been reprocessed and all records have been updated to the Electronic Eligibility Management System.',
    },
    {
      statusCode: 'CMPL REPR ALL WITH WRN',
      explantion:
        'Transaction set has been reprocessed, but with low severity errors (warnings) detected on some records.  All records have been updated to the Electronic Eligibility Management System; however those records with warnings should be corrected by the customer via the next file submission to resolve inaccurate data.',
    },
    {
      statusCode: 'CMPL REPR ALL WITH ERR',
      explantion:
        'Tranaction set has been reprocessed, but with errors detected on some records.  Those records not in error have been updated to the Electronic Eligibility Management System, error records are pended in the Electronic Eligibility Management System process until resolved by the Electronic Eligibility Analyst assigned to the submission group or corrected by a new file submission from the customer.',
    },
    {
      statusCode: 'CMPL REPR PART',
      explantion:
        'Some transactions within this transaction set have been reprocessed and all records have been updated to the Electronic Eligibility Management System.',
    },
    {
      statusCode: 'CMPL REPR PART WITH WRN',
      explantion:
        'Some transactions within this transaction set have been reprocessed, but with low severity errors (warnings) detected on some records.  All records have been updated to the Electronic Eligibility Management System; however those records with warnings should be corrected by the customer via the next file submission to resolve inaccurate data.',
    },
    {
      statusCode: 'REPR THRESH XCD',
      explantion:
        'Thresholds violations were encountered during re-processing.  Entire transaction set is in error on the Electronic Eligibility Management System until researched and corrected by the Electronic Eligibility Analyst assigned to the submission group.',
    },
  ];
  var enrollProcReq = [
    { fieldName: 'Severity' },
    {
      fieldName: 'Error or Warning Name',
      description: 'Identifies the cause of the error/warning.',
    },
    {
      fieldName: 'Count',
      description:
        'The number of errors generated for the Error or Warning Name',
    },
    {
      fieldName: 'Total',
      description:
        'The total number of errors requiring Enrollment Processor Correction',
    },
  ];
  var severityCodeJsonArr = [
    {
      sevCode: '1 - Critical',
      explantion:
        'Transaction is held up in the Electronic Eligibility Management System process and updates are not sent back to CSP.',
    },
    {
      sevCode: '4 - Error',
      explantion:
        'Subscribers update is made to the destination system, but certain data requires update for accuracy. The segment which generated the error may not be sent to CSP but the rest of the member will be processed.',
    },
    {
      sevCode: '5 - Warning',
      explantion:
        'For information only. Subscribers update is made to the destination system, but certain data requires update for accuracy. Warning is used to alert the EEA that some unexpected values were received.',
    },
  ];

  var custCorrecReq = [
    { fieldName: 'Severity' },

    {
      fieldName: 'Error or Warning Name',
      description: 'Identifies the cause of the error.',
    },
    {
      fieldName: 'Count',
      description:
        'The number of errors generated for the Error or Warning Name.',
    },
    {
      fieldName: 'Total',
      description:
        'The total number of errors requiring Eligibility Analyst correction.',
    },
  ];
  var severityCodeCustCorrJsonArr = [
    {
      sevCode: '1 - Priority',
      explantion:
        'Subscriber/Dependent does not have coverage on the destination system without resolution to this error.  Transaction is held up in the Electronic Eligibility Management System process.  Examples:  New employee/dependent add, new coverage add.',
    },
    {
      sevCode: '2 - ID Card Impact',
      explantion:
        'Subscribers update could not be made in the destination system without resolution to this error    Transaction is held up in the Electronic Eligibility Management System process. The failure of this update may have an impact on ID Cards.Example: name change',
    },
    {
      sevCode: '3 - Claim Impact',
      explantion:
        'Subscribers update could not be made in the destination system without resolution to this error.Transaction is held up in the Electronic Eligibility Management System process.The failure to make this update will have an impact on claim payment.Example: plan change moving from a POS to a PPO plan, termination of coverage.',
    },
    {
      sevCode: '4 - Warning',
      explantion:
        'Subscribers update is made to the destination system, but certain data requires update for accuracy. Example: Address Overlay',
    },
    {
      sevCode: '5 - PCP Warning',
      explantion:
        'Subscribers update is made to the destination system, missing subscriber has been loaded in a Gatekeeper Plan without a valid PCP.',
    },
  ];
  var eligAnalCorrecReq = [
    { fieldName: 'Severity (CES/CDB)' },
    { fieldName: 'Severity(CSP)' },
    {
      fieldName: 'Error or Warning Name',
      description: 'Identifies the cause of the error.',
    },
    {
      fieldName: 'Count',
      description:
        'The number of errors generated for the Error or Warning Name.',
    },
    {
      fieldName: 'Total',
      description:
        'The total number of errors requiring Eligibility Analyst correction.',
    },
  ];
  var severityCesCodeJsonArr = [
    {
      sevCode: '1 - Priority',
      explantion:
        'Subscriber/Dependent does not have coverage on the destination system without resolution to this error.  Transaction is held up in the Electronic Eligibility Management System process.  Examples:  New employee/dependent add, new coverage add.',
    },
    {
      sevCode: '2 - ID Card Impact',
      explantion:
        'Subscribers update could not be made in the destination system without resolution to this error    Transaction is held up in the Electronic Eligibility Management System process. The failure of this update may have an impact on ID Cards.Example: name change',
    },
    {
      sevCode: '3 - Claim Impact',
      explantion:
        'Subscribers update could not be made in the destination system without resolution to this error.Transaction is held up in the Electronic Eligibility Management System process.The failure to make this update will have an impact on claim payment.Example: plan change moving from a POS to a PPO plan, termination of coverage.',
    },
    {
      sevCode: '4 - Warning',
      explantion:
        'Subscribers update is made to the destination system, but certain data requires update for accuracy. Example: Address Overlay',
    },
    {
      sevCode: '5 - PCP Warning',
      explantion:
        'Subscribers update is made to the destination system, missing subscriber has been loaded in a Gatekeeper Plan without a valid PCP.',
    },
  ];
  var severityCspCodeJsonArr = [
    {
      sevCode: '1 - Critical',
      explantion:
        'Transaction is held up in the Electronic Eligibility Management System process and updates are not sent back to CSP..',
    },
    {
      sevCode: '4 - Error',
      explantion:
        'Subscribers update is made to the destination system, but certain data requires update for accuracy. The segment which generated the error may not be sent to CSP but the rest of the member will be processed.',
    },
    {
      sevCode: '5 - Warning',
      explantion:
        'For information only. Subscribers update is made to the destination system, but certain data requires update for accuracy. Warning is used to alert the EEA that some unexpected values were received..',
    },
  ];
  return (
    <>
      <p>
        The Error and Warning Summary page displays a list of all errors and
        warnings and the corresponding count for a file processing date. The
        errors and warnings are separated by owner, customer or eligibility
        analyst. Click on the error or warning name to view the list of all the
        transactions with that corresponding error or warning.
      </p>
      <Table.Container title="Manual Static Table">
        <Table.TableHeader>
          <Table.TableHeaderRow>
            <Table.Column>Field Name</Table.Column>
            <Table.Column>Description</Table.Column>
          </Table.TableHeaderRow>
        </Table.TableHeader>
        {errWarnJsonArr.map((item) => (
          <Table.TableBody>
            {!(item.fieldName === 'Processing Status') && (
              <Table.Row>
                <Table.Cell>{item.fieldName}</Table.Cell>
                <Table.Cell>{item.description}</Table.Cell>
              </Table.Row>
            )}
            {item.fieldName === 'Processing Status' && (
              <Table.Row>
                <Table.Cell>Processing Status</Table.Cell>
                <Table.Cell>
                  {' '}
                  <Table.Container title="">
                    <Table.TableHeader>
                      <Table.TableHeaderRow>
                        <Table.Column>Status Code</Table.Column>
                        <Table.Column>Explanation</Table.Column>
                      </Table.TableHeaderRow>
                    </Table.TableHeader>

                    <Table.TableBody>
                      {procStatusJsonArr.map((item2) => (
                        <Table.Row>
                          <Table.Cell>{item2.statusCode}</Table.Cell>
                          <Table.Cell>{item2.explantion}</Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.TableBody>
                  </Table.Container>
                </Table.Cell>
              </Table.Row>
            )}
          </Table.TableBody>
        ))}
      </Table.Container>
      <h4>Enrollment Processor Correction Required</h4>
      <Table.Container title="Manual Static Table">
        <Table.TableHeader>
          <Table.TableHeaderRow>
            <Table.Column>Field Name</Table.Column>
            <Table.Column>Description</Table.Column>
          </Table.TableHeaderRow>
        </Table.TableHeader>
        {enrollProcReq.map((item) => (
          <Table.TableBody>
            {item.fieldName === 'Severity' && (
              <Table.Row>
                <Table.Cell>Severity</Table.Cell>
                <Table.Cell>
                  {' '}
                  <Table.Container title="">
                    <Table.TableHeader>
                      <Table.TableHeaderRow>
                        <Table.Column>Status Code</Table.Column>
                        <Table.Column>Explanation</Table.Column>
                      </Table.TableHeaderRow>
                    </Table.TableHeader>

                    <Table.TableBody>
                      {severityCodeJsonArr.map((item3) => (
                        <Table.Row>
                          <Table.Cell>{item3.sevCode}</Table.Cell>
                          <Table.Cell>{item3.explantion}</Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.TableBody>
                  </Table.Container>
                </Table.Cell>
              </Table.Row>
            )}
            {item.fieldName != 'Severity' && (
              <Table.Row>
                <Table.Cell>{item.fieldName}</Table.Cell>
                <Table.Cell>{item.description}</Table.Cell>
              </Table.Row>
            )}
          </Table.TableBody>
        ))}
      </Table.Container>
      <h4>Customer Correction Required</h4>
      <Table.Container title="Manual Static Table">
        <Table.TableHeader>
          <Table.TableHeaderRow>
            <Table.Column>Field Name</Table.Column>
            <Table.Column>Description</Table.Column>
          </Table.TableHeaderRow>
        </Table.TableHeader>
        {custCorrecReq.map((item) => (
          <Table.TableBody>
            {item.fieldName === 'Severity' && (
              <Table.Row>
                <Table.Cell>Severity</Table.Cell>
                <Table.Cell>
                  {' '}
                  <Table.Container title="">
                    <Table.TableHeader>
                      <Table.TableHeaderRow>
                        <Table.Column>Severity Code - Description</Table.Column>
                        <Table.Column>Explanation</Table.Column>
                      </Table.TableHeaderRow>
                    </Table.TableHeader>

                    <Table.TableBody>
                      {severityCodeCustCorrJsonArr.map((item3) => (
                        <Table.Row>
                          <Table.Cell>{item3.sevCode}</Table.Cell>
                          <Table.Cell>{item3.explantion}</Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.TableBody>
                  </Table.Container>
                </Table.Cell>
              </Table.Row>
            )}
            {item.fieldName != 'Severity' && (
              <Table.Row>
                <Table.Cell>{item.fieldName}</Table.Cell>
                <Table.Cell>{item.description}</Table.Cell>
              </Table.Row>
            )}
          </Table.TableBody>
        ))}
      </Table.Container>
      <h4>Eligibility Analyst Correction Required</h4>
      <Table.Container title="Manual Static Table">
        <Table.TableHeader>
          <Table.TableHeaderRow>
            <Table.Column>Field Name</Table.Column>
            <Table.Column>Description</Table.Column>
          </Table.TableHeaderRow>
        </Table.TableHeader>
        {eligAnalCorrecReq.map((item) => (
          <Table.TableBody>
            {item.fieldName === 'Severity (CES/CDB)' && (
              <Table.Row>
                <Table.Cell>Severity (CES/CDB)</Table.Cell>
                <Table.Cell>
                  {' '}
                  <Table.Container title="">
                    <Table.TableHeader>
                      <Table.TableHeaderRow>
                        <Table.Column>Severity Code - Description</Table.Column>
                        <Table.Column>Explanation</Table.Column>
                      </Table.TableHeaderRow>
                    </Table.TableHeader>

                    <Table.TableBody>
                      {severityCesCodeJsonArr.map((item3) => (
                        <Table.Row>
                          <Table.Cell>{item3.sevCode}</Table.Cell>
                          <Table.Cell>{item3.explantion}</Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.TableBody>
                  </Table.Container>
                </Table.Cell>
              </Table.Row>
            )}
            {item.fieldName === 'Severity(CSP)' && (
              <Table.Row>
                <Table.Cell>Severity(CSP)</Table.Cell>
                <Table.Cell>
                  {' '}
                  <Table.Container title="">
                    <Table.TableHeader>
                      <Table.TableHeaderRow>
                        <Table.Column>Severity Code - Description</Table.Column>
                        <Table.Column>Explanation</Table.Column>
                      </Table.TableHeaderRow>
                    </Table.TableHeader>

                    <Table.TableBody>
                      {severityCspCodeJsonArr.map((item3) => (
                        <Table.Row>
                          <Table.Cell>{item3.sevCode}</Table.Cell>
                          <Table.Cell>{item3.explantion}</Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.TableBody>
                  </Table.Container>
                </Table.Cell>
              </Table.Row>
            )}
            {!item.fieldName.includes('Severity') && (
              <Table.Row>
                <Table.Cell>{item.fieldName}</Table.Cell>
                <Table.Cell>{item.description}</Table.Cell>
              </Table.Row>
            )}
          </Table.TableBody>
        ))}
      </Table.Container>
    </>
  );
};
